export default __webpack_public_path__ + "static/media/Inter-UI-ExtraBold.de0e325d.woff2";